<template>

  <div class="mt-4">
    <div class="row">
      <div class="col-md-12">
        <b-card class="mt-2 mb-4 shadow-sm">
          <b-form v-unsave-detector @submit.stop.prevent="clickOnValidateBtn">
            <div class="row">
              <div class="col-md-6">
                <label class="font-weight-bolder">{{ this.currentStep + 1 + " sur 4" }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="font-weight-bolder secondary-color h6">{{ $t('operation.dossier.step3.2.title') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="mb-3">{{ $t('operation.dossier.step3.2.subtitle') }}</label>
              </div>
            </div>
            <template v-for="(etude, index) in edudesMarche">
              <div class="row">
                <div class="col-md-8">
                  <div class="d-flex mb-2">
                    <span class="medium-text mr-2"> {{ $t('operation.dossier.field.text') }}</span>
                    <span class="italic-text"> {{ $t('operation.dossier.field.max.length') }}</span>
                  </div>
                  <VueEditor :id="`legende-input-${index}`" ref="editor"
                             v-model="etude.legende.value" :editorToolbar="customToolbar" @input="limitText"
                             v-on:input="emitChangeValue"></VueEditor>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    :invalid-feedback="etude.photo.invalidFeedback"
                    class="medium-label mb-4">
                    <div class="d-flex">
                      <label :for="`photo-input-${index}`">
                        {{ $t('operation.dossier.field.image') }}
                      </label>
                    </div>
                    <custom-form-file
                      :id="`photo-input-${index}`"
                      v-model="etude.photo.value"
                      :drop-placeholder="$t('drop-placeholder')"
                      :placeholder="etude.photo.value"
                      :state="etude.photo.state"
                      accept=".png, .jpeg, .jpg"
                      @preview="etude.photo.preview = $event"
                    />
                    <div>
                      <img v-if="etude.photo.preview" :src="etude.photo.preview" alt="Image preview"
                           class="mt-1 preview-image"/>
                      <img v-else-if="etude.photo.value" :src="getFileUrl(etude.photo.fileUrl)"
                           alt="Image preview" class="preview-image"/>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-1 d-flex">
                  <b-button v-if="etude.id" class="btn-medium secondary-color" variant="outline"
                            @click="deleteEtudeDeMarche(etude.id)">
                    <trash-icon class="mr-1" size="30"/>
                  </b-button>
                  <b-button v-else class="btn-medium secondary-color" variant="outline" @click="removeEDM(index)">
                    <trash-icon class="mr-1" size="30"/>
                  </b-button>
                </div>
              </div>
            </template>
            <div class="col-4">
              <b-button class="btn-medium bold-text" variant="outline" @click="addEDM">
                <plus-icon class="mr-1 vc-red" size="15"/>
                {{ $t('operation.dossier.step.add') }}
              </b-button>
            </div>
            <div class="d-flex justify-content-end">
              <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t('Back') }}</b-button>
              <b-button type="submit" variant="primary">{{ $t('next') }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../../../services/api'
import {VueEditor} from "vue2-editor";
import CustomFormFile from "../../../components/b122/editFields/CustomFormFile.vue";

export default {
  name: "DossierOperationEDM",
  components: {
    CustomFormFile,
    VueEditor
  },
  props: {
    currentStep: Number,
    dossierId: Number,
    edmCreationDone: Boolean

  },

  data() {
    return {
      textLimitLength: 250,
      edudesMarche: [],

      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        ['blockquote', 'code-block'],
        [{list: "ordered"}, {list: "bullet"}],
      ],
      imagePreview: null,
    }
  },
  emits: ['didContinueEDM', 'didBack', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
  },


  methods: {
    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl;
    },


    updateImagePreview(etude, file) {
      if (file) {
        etude.photo.preview = URL.createObjectURL(file);
      } else {
        etude.photo.preview = null;
      }
      this.emitChangeValue();
    },

    removeEDM(index) {
      this.edudesMarche.splice(index, 1);
    },


    addEDM() {
      this.edudesMarche.push({
        id: null,
        legende:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        photo:
          {
            state: null,
            invalidFeedback: null,
            value: null,
            fileUrl: null
          }
      })
    },

    limitText() {
      const quill = this.$refs.editor[0].quill
      const len = quill.getText().length
      if (len >= this.textLimitLength) {
        quill.deleteText(this.textLimitLength, len);
      }
    },

    async deleteEtudeDeMarche(id) {
      if (id != null) {
        await api
          .delete(`/marketStudy/${id}`)
          .then(() => {
            this.edudesMarche = this.edudesMarche.filter(etude => etude.id !== id);
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },


    async fetchData() {
      if (this.dossierId && this.edmCreationDone) {
        await this.fetchEtudeDeMarche()
      }
    },

    async fetchEtudeDeMarche() {
      await api
        .get(`/marketStudy/getMarketStudiesByDossier/${this.dossierId}`)
        .then(response => {
          this.edudesMarche = response.data.map(item => ({
            id: item.id,
            legende: {
              state: item.legendeState || null,
              invalidFeedback: item.legendeInvalidFeedback || null,
              value: item.recherche || null
            },
            photo: {
              state: item.photoState || null,
              invalidFeedback: item.photoInvalidFeedback || null,
              value: item.photo != null ? item.photo.filename : null,
              fileUrl: item.photo != null ? item.photo.fileUrl : null
            }
          }));
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    /** Bouton validate (Etape suivante)
     *  save + redirection vers l'étape 2 de la création d'operation + success toast
     */
    clickOnValidateBtn() {
      this._save(response => {
        this.$emit('didContinueEDM', response.data.id)
      }, () => {
        this.$nextTick(() => {
          this.successToast("test", 'f.added')
        })
      })
    },

    /** Bouton save (Sauvegarder)
     *  save + success toast (pas de redirection)
     */


    /** Enregistrement des infos de l'operation en db
     *  POST si l'operation n'existe pas - PUT si c'est une modification (type d'operation non modifiable)
     * @param onSuccessClosure (effectuée si l'enregistrement en db fonctionne)
     */
    _save(onSuccessClosure) {
      let data = new FormData();
      data.append('dossierId', this.dossierId);

      let marketStudies = this.edudesMarche.map((study, index) => {
        data.append(`photo[${index}]`, study.photo.value);
        return {
          legende: study.legende.value,
          photo: `photo[${index}]`,
          id: study.id
        };
      });

      data.append('marketStudies', JSON.stringify(marketStudies));
      api({
        method: 'POST',
        url: 'marketStudy',
        data: data
      })
        .then((response) => {
          if (onSuccessClosure) onSuccessClosure(response)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField;
            this.form[invalidField]['state'] = false;
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message);
          }
        });
    },


    /** Success toast quand l'operation est créée/modifiée
     */
    successToast(operationName, actionName) {
      this.$bvToast.toast("Situation opération" + this.$i18n.t(actionName), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    back() {
      this.$emit('didBack')
    },
  },
}
</script>

<style scoped>
#legende-input {
  height: 100px !important;

}
</style>



// WEBPACK FOOTER //
// src/views/operationDossier/dossierOperationCreateSteps/DossierOperationEDM.vue